import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/service/auth.service';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppLog } from '../../../../core/util/log.util';

@Component({
  selector: 'app-mail-entry',
  templateUrl: './mail-entry.component.html',
  styleUrl: './mail-entry.component.scss'
})
export class MailEntryComponent implements OnInit {

    constructor(
      private authService: AuthService,
      private router: Router,
      private route: ActivatedRoute
    ) {}

    ngOnInit(): void {

      // tároljuk az URL-t amit a levélből kaptunk
      this.authService.requestedUrl.set(this.router.url);

      if (this.authService.getProfile()) {

        let url = this.router.url.replace('/offers', '/order');
        let urlParts = url.split('?');
        let fragParts = urlParts[1].split('=');

        let baseUrl: any[] = urlParts[0].replace('/complete', '').split('/');
        
        let filteredUrl = ['/'];
        filteredUrl = [...filteredUrl, ...baseUrl.filter(function (el) {
          return el != null && el != '';
        })];

        let finalUrl = filteredUrl.join('/').replace('portal', '');

        AppLog.log('Final url:', finalUrl);

        this.router.navigate([finalUrl]); // , { fragment: { v: fragParts[1] } });

      } else {
        AppLog.message('User logged out, storing requested URL and redirecting');
        this.router.navigate(['/auth/login']);
      }

    }

}
